import { get } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchWholesalers = () => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get('/wholesalers', { pagination: false }).then(wholesalers => {
    dispatch({
      type: types.FETCH_WHOLESALERS,
      payload: {
        wholesalers: wholesalers['hydra:member'],
      },
    });
  });
